import { deleteRequest } from '@/core';
import { maintenance } from '@/requests';

export default async function deleteDeviationCauseRequest(idToDelete) {
	let url = maintenance.getDeviationCausesByIdPath(idToDelete);
	return deleteRequest(url);
}